import React from "react";
import {
  RefreshCw,
  Cpu,
  ShieldCheck,
  Zap,
  ArrowUpCircle,
  Upload,
  X,
  UploadCloud,
  FileText,
} from "lucide-react";
import { useEffect, useState } from "react";

const FirmwarePage = () => {
  const [devices, setDevices] = useState([]);
  const [deviceFirmwareMap, setDeviceFirmwareMap] = useState({});
  const [highestVersion, setHighestVersion] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [version, setVersion] = useState("");
  const [description, setDescription] = useState("");
  const [firmwareFile, setFirmwareFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const userRole = localStorage.getItem("role");
  const userId = localStorage.getItem("id");
  useEffect(() => {
    fetchFirmware();
    fetchDeviceFirmwareVersions(); // ✅ ADD THIS
    // eslint-disable-next-line
  }, []);
  const [activeTab, setActiveTab] = useState("select"); // "select" or "upload"
  const [availableFirmwares, setAvailableFirmwares] = useState([]);
  const [selectedFirmwareUrl, setSelectedFirmwareUrl] = useState("");
  const fetchFirmware = async () => {
    try {
      const res = await fetch(
        `https://db2sg.com/tagweigh/api/firmware?latest=all&_t=${Date.now()}`
      );
      const data = await res.json();
      console.log(data);
      let allDevices = data.data || [];
      if (userRole === "user") {
        allDevices = allDevices.filter(
          (d) =>
            d.user?.toString() === userId?.toString() || d.device_id === userId
        );
      }

      setDevices(allDevices);
      setHighestVersion(data.highest_version);
    } catch (e) {
      console.error("Firmware load failed", e);
    } finally {
    }
  };
  const fetchDeviceFirmwareVersions = async () => {
    try {
      const res = await fetch(
        "https://db2sg.com/tagweigh/api/device_firmware?action=list"
      );

      const data = await res.json();

      if (data.success && data.devices) {
        let map = {};

        data.devices.forEach((d) => {
          map[d.mac.toLowerCase()] = d.version;
        });

        setDeviceFirmwareMap(map);
      }
    } catch (err) {
      console.error("Failed to fetch device firmware versions", err);
    }
  };
  const sites = devices.map((d) => {
    const macLower = d.device_id.toLowerCase();

    // ✅ Version from JSON API
    const deviceVersion = deviceFirmwareMap[macLower] || "--";

    // ✅ Compare with highest version
    const status =
      deviceVersion !== "--" &&
      parseFloat(deviceVersion) === parseFloat(highestVersion)
        ? "Up to Date"
        : "Update Available";

    return {
      name: d.name,
      mac: d.device_id,
      version: deviceVersion === "--" ? "--" : `V${deviceVersion}`,
      status,
      last_heartbeat: d.last_heartbeat,
    };
  });

  // const sites = devices.map((d) => ({
  //   name: d.name,
  //   mac: d.device_id,
  //   version: `V${d.version}`,
  //   status: d.version === highestVersion ? "Up to Date" : "Update Available",
  //   last_heartbeat: d.last_heartbeat,
  // }));
  // const openModal = (device) => {
  //   setSelectedDevice(device);
  //   setVersion(highestVersion); // prefill with highest version
  //   setDescription("");
  //   setFirmwareFile(null);
  //   setShowModal(true);
  // };
  const openModal = async (device) => {
    setSelectedDevice(device);
    setShowModal(true);

    try {
      // Fetch available firmware files from your PHP API
      const res = await fetch(
        "https://db2sg.com/tagweigh/api/firmware_updates?from_date=2026-01-15"
      );
      const data = await res.json();
      setAvailableFirmwares(data.files || []);
    } catch (err) {
      console.error("Failed to load firmware list", err);
    }
  };
  const handleUpdateViaUrl = async (e) => {
    e.preventDefault();
    //setUploading(true);

    if (!selectedFirmwareUrl || !selectedDevice) {
      alert("Please select a firmware version!");
      return;
    }

    // Find the selected firmware details to get the version string
    const selectedFw = availableFirmwares.find(
      (f) => f.filename === selectedFirmwareUrl
    );

    const formData = new FormData();
    formData.append("device_id", selectedDevice.mac);
    formData.append("version", selectedFw.version);
    formData.append("file_url", selectedFirmwareUrl);

    try {
      // Notice the action=update_url parameter for your PHP logic
      const res = await fetch(
        "https://db2sg.com/tagweigh/api/firmware_updates?action=update_url",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await res.json();
      if (data.success) {
        setShowModal(false); // Close state first
        setTimeout(() => {
          // Give React a tiny bit of time to unmount the modal
          alert(`Firmware uploaded successfully!`);
          window.location.reload();
        }, 100);
      } else {
        alert("Update failed: " + data.error);
      }
    } catch (err) {
      alert("Network error occurred.");
    } finally {
      setUploading(false);
    }
  };
  const isDeviceOffline = (lastTime) => {
    if (!lastTime) return true;
    const time = new Date(lastTime.replace(" ", "T") + "Z");
    const diff = (Date.now() - time.getTime()) / 1000;
    return diff >= 60;
  };
  useEffect(() => {
    fetchFirmware();

    const interval = setInterval(() => {
      fetchFirmware();
    }, 20000);

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, []);

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!version || !selectedDevice || !firmwareFile) {
      alert("Version, Device ID, and firmware file are required!");
      return;
    }

    const formData = new FormData();
    formData.append("version", version);
    formData.append("device_id", selectedDevice.mac);
    formData.append("description", description);
    formData.append("firmware", firmwareFile);
    setUploading(true);

    try {
      const res = await fetch(
        "https://db2sg.com/tagweigh/api/firmware/upload",
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await res.json();
      if (data.success) {
        // alert(`Firmware uploaded successfully for ${selectedDevice.mac}, version ${version}`);
        // setShowModal(false);
        // fetchFirmware();
        setShowModal(false);

        alert(
          `Firmware uploaded successfully for ${selectedDevice.mac}, version ${version}`
        );
        window.location.reload();
      } else {
        alert("Upload failed: " + JSON.stringify(data));
      }
    } catch (err) {
      console.error(err);
      alert("Upload failed due to network error.");
    } finally {
      setUploading(false);
    }
  };
  return (
    <div className="animate-in fade-in slide-in-from-bottom-8 duration-1000 pb-20 ltr">
      {/* 2. Device Update List */}
      <div className="space-y-6">
        {sites.map((site) => (
          <div
            key={site.mac + activeTab+site.last_heartbeat}
            className="bg-white rounded-[2.5rem] border border-slate-100 p-8 shadow-sm flex flex-col md:flex-row items-center justify-between gap-6 hover:shadow-xl transition-all duration-500 group"
          >
            <div className="flex items-center gap-6">
              <div
                className={`w-16 h-16 rounded-3xl flex items-center justify-center transition-colors ${
                  site.status === "Up to Date"
                    ? "bg-emerald-50 text-emerald-600 animate-pulse group-hover:bg-emerald-50 group-hover:text-emerald-500"
                    : "bg-blue-50 text-blue-600 animate-pulse"
                }`}
              >
                <Cpu size={32} />
              </div>
              <div>
                <h4 className="text-xl font-black text-slate-800 mb-1">
                  {site.name}
                </h4>
                <div className="flex items-center gap-3">
                  <span className="text-[10px] font-mono font-bold text-slate-400 tracking-tighter uppercase">
                    MAC: {site.mac}
                  </span>
                  <span className="h-1 w-1 rounded-full bg-slate-200"></span>
                  <span className="bg-slate-900 text-blue-400 text-[10px] font-mono font-bold px-2 py-0.5 rounded italic">
                    {site.version}
                  </span>
                  {isDeviceOffline(site.last_heartbeat) ? (
                    <span className="bg-red-50 text-red-600 text-[10px] font-black px-3 py-1 rounded-full uppercase">
                      Offline
                    </span>
                  ) : (
                    <span className="bg-emerald-50 text-emerald-600 text-[10px] font-black px-3 py-1 rounded-full uppercase">
                      Online
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div
              onClick={() => openModal(site)}
              className="flex items-center gap-6"
            >
              <div
                className={`flex items-center gap-2 px-5 py-2 rounded-full text-[10px] font-black uppercase tracking-widest ${
                  site.status === "Up to Date"
                    ? "bg-emerald-100 text-emerald-700"
                    : "bg-blue-100 text-blue-700"
                }`}
              >
                {site.status === "Up to Date" ? (
                  <ShieldCheck size={14} />
                ) : (
                  <ArrowUpCircle size={14} />
                )}
                {site.status === "Up to Date" ? "עדכני" : "עדכון זמין"}
              </div>

              <button
                className={`p-4 rounded-2xl transition-all ${
                  site.status === "Up to Date"
                    ? "bg-emerald-100 text-emerald-700 hover:text-slate-600"
                    : "bg-blue-600 text-white shadow-lg shadow-blue-500/30 hover:scale-110"
                }`}
              >
                {site.status === "Up to Date" ? (
                  <UploadCloud size={18} />
                ) : (
                  <Zap size={18} />
                )}
              </button>
            </div>
          </div>
        ))}
      </div>
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="bg-white rounded-[2.5rem] p-0 max-w-md w-full relative shadow-2xl overflow-hidden border">
            {/* Header */}
            <div className="p-8 pb-4">
              <button
                onClick={() => setShowModal(false)}
                className="absolute top-8 right-8 text-slate-400 hover:text-slate-900"
              >
                <X size={24} />
              </button>
              <h3 className="text-2xl font-black text-slate-800">
                Firmware Update
              </h3>
              <p className="text-slate-500 text-xs font-bold uppercase mt-1">
                Device: {selectedDevice?.name}
              </p>
            </div>

            {/* Tab Switcher */}
            <div className="flex px-8 gap-2 mb-6">
              <button
                onClick={() => setActiveTab("select")}
                className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-2xl text-xs font-black transition-all ${
                  activeTab === "select"
                    ? "bg-blue-600 text-white shadow-lg"
                    : "bg-slate-100 text-slate-500"
                }`}
              >
                <RefreshCw size={14} /> SELECT
              </button>
              <button
                onClick={() => setActiveTab("upload")}
                className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-2xl text-xs font-black transition-all ${
                  activeTab === "upload"
                    ? "bg-blue-600 text-white shadow-lg"
                    : "bg-slate-100 text-slate-500"
                }`}
              >
                <Upload size={14} /> UPLOAD
              </button>
            </div>

            <div className="px-8 pb-8">
              {activeTab === "select" ? (
                <div key="select-tab-container">
                  <form onSubmit={handleUpdateViaUrl} className="space-y-6">
                    <div>
                      <label className="block mb-2 font-black text-slate-700 text-sm italic">
                        Available Versions on Server
                      </label>
                      <select
                        className="w-full p-4 border-2 border-slate-100 rounded-2xl bg-slate-50 font-bold focus:border-blue-500 outline-none"
                        value={selectedFirmwareUrl}
                        onChange={(e) => setSelectedFirmwareUrl(e.target.value)}
                        required
                      >
                        <option value="">-- Choose File --</option>

                        {availableFirmwares
                          .slice()
                          .sort(
                            (a, b) =>
                              parseFloat(b.version) - parseFloat(a.version)
                          )
                          .map((fw) => {
                            const cleanName = fw.filename.replace(
                              /^fw_[a-zA-Z0-9]+_/,
                              "fw_"
                            );

                            return (
                              <option key={fw.filename} value={fw.filename}>
                                V{fw.version} - {cleanName}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                    <button
                      type="submit"
                      disabled={uploading || !selectedFirmwareUrl}
                      className="w-full flex items-center justify-center gap-3 px-6 py-4 bg-blue-600 text-white rounded-2xl font-black hover:bg-blue-700 transition-all shadow-lg shadow-blue-200 disabled:bg-slate-300"
                    >
                    
                    </button>
                  </form>
                </div>
              ) : (
                <div key="upload-tab-container">
                  <form onSubmit={handleUpload} className="space-y-4">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block mb-1 text-xs font-bold text-slate-500">
                          Version
                        </label>
                        <input
                          type="text"
                          value={version}
                          onChange={(e) => setVersion(e.target.value)}
                          className="w-full p-3 border rounded-xl font-bold bg-slate-50"
                          placeholder="e.g. 1.6"
                          required
                        />
                      </div>
                      <div>
                        <label className="block mb-1 text-xs font-bold text-slate-500">
                          Description
                        </label>
                        <input
                          type="text"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                          className="w-full p-3 border rounded-xl font-bold bg-slate-50"
                          placeholder="Changelog"
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block mb-1 text-xs font-bold text-slate-500">
                        Bin File
                      </label>
                      <div className="relative border-2 border-dashed border-slate-200 rounded-2xl p-4 hover:border-blue-400 transition-colors bg-slate-50">
                        <input
                          type="file"
                          accept=".bin"
                          onChange={(e) => setFirmwareFile(e.target.files[0])}
                          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                          required
                        />
                        <div className="flex items-center gap-3 text-slate-500">
                          <FileText size={24} />
                          <span className="text-xs font-bold truncate">
                            {firmwareFile
                              ? firmwareFile.name
                              : "Select .bin file..."}
                          </span>
                        </div>
                      </div>
                    </div>
                    <button
                      type="submit"
                      disabled={uploading}
                      className="w-full flex items-center justify-center gap-3 px-6 py-4 bg-blue-600 text-white rounded-2xl font-black hover:bg-emerald-700 transition-all shadow-lg shadow-blue-200 disabled:bg-slate-300"
                    >
            
                      {uploading ? (
  <>
    <RefreshCw size={18} className="animate-spin" />
    <span>Uploading...</span> 
  </>
) : (
  <>
    <UploadCloud size={18} />
    <span>Upload & Deploy</span>
  </>
)}
                    </button>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FirmwarePage;
